import { render, staticRenderFns } from "./MmdPaperDemoSumoMost.vue?vue&type=template&id=282c184c&scoped=true"
import script from "./MmdPaperDemoSumoMost.vue?vue&type=script&lang=js"
export * from "./MmdPaperDemoSumoMost.vue?vue&type=script&lang=js"
import style0 from "./MmdPaperDemoSumoMost.vue?vue&type=style&index=0&id=282c184c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282c184c",
  null
  
)

export default component.exports